// src/pages/EventEditor/RichTextToolbar.jsx
import React from 'react';
import PropTypes from 'prop-types';
import './RichTextToolbar.css';

function RichTextToolbar({ block, onUpdate }) {
  const fontSize = block.fontSize || '16';
  const fontFamily = block.fontFamily || 'Marianne';
  const fontWeight = block.fontWeight || 'normal';
  const fontStyle = block.fontStyle || 'normal';
  const textDecoration = block.textDecoration || 'none';
  const textAlign = block.textAlign || 'left';

  const fontSizes = [
    { value: '12', label: '12px' },
    { value: '14', label: '14px' },
    { value: '16', label: '16px' },
    { value: '18', label: '18px' },
    { value: '20', label: '20px' },
    { value: '24', label: '24px' },
    { value: '28', label: '28px' },
    { value: '32', label: '32px' },
    { value: '36', label: '36px' },
    { value: '42', label: '42px' },
    { value: '48', label: '48px' },
  ];

  const fontFamilies = [
    { value: 'Marianne', label: 'Marianne' },
    { value: 'Arial', label: 'Arial' },
  ];

  const handleFontSizeChange = (e) => {
    onUpdate({ fontSize: e.target.value });
  };

  const handleFontFamilyChange = (e) => {
    onUpdate({ fontFamily: e.target.value });
  };

  const toggleBold = () => {
    onUpdate({ fontWeight: fontWeight === 'bold' ? 'normal' : 'bold' });
  };

  const toggleItalic = () => {
    onUpdate({ fontStyle: fontStyle === 'italic' ? 'normal' : 'italic' });
  };

  const toggleUnderline = () => {
    onUpdate({
      textDecoration: textDecoration === 'underline' ? 'none' : 'underline',
    });
  };

  const setTextAlign = (align) => {
    onUpdate({ textAlign: align });
  };

  return (
    <div className="richtext-toolbar">
      <div className="toolbar-section">
        <div className="form-group">
          <label>Police</label>
          <select
            value={fontFamily}
            onChange={handleFontFamilyChange}
            className="toolbar-select"
          >
            {fontFamilies.map((font) => (
              <option key={font.value} value={font.value}>
                {font.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="toolbar-section">
        <div className="form-group ">
          <label>Taille</label>
          <select
            value={fontSize}
            onChange={handleFontSizeChange}
            className="toolbar-select"
          >
            {fontSizes.map((size) => (
              <option key={size.value} value={size.value}>
                {size.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="toolbar-section">
        <label>Format</label>
        <div className="toolbar-buttons">
          <button
            type="button"
            className={`toolbar-btn ${fontWeight === 'bold' ? 'active' : ''}`}
            onClick={toggleBold}
            title="Gras"
          >
            <strong>B</strong>
          </button>
          <button
            type="button"
            className={`toolbar-btn ${fontStyle === 'italic' ? 'active' : ''}`}
            onClick={toggleItalic}
            title="Italique"
          >
            <em>I</em>
          </button>
          <button
            type="button"
            className={`toolbar-btn ${
              textDecoration === 'underline' ? 'active' : ''
            }`}
            onClick={toggleUnderline}
            title="Souligné"
          >
            <u>U</u>
          </button>
        </div>
      </div>

      <div className="toolbar-section">
        <label>Alignement</label>
        <div className="toolbar-buttons">
          <button
            type="button"
            className={`toolbar-btn ${textAlign === 'left' ? 'active' : ''}`}
            onClick={() => setTextAlign('left')}
            title="Aligner à gauche"
          >
            &#8676;
          </button>
          <button
            type="button"
            className={`toolbar-btn ${textAlign === 'center' ? 'active' : ''}`}
            onClick={() => setTextAlign('center')}
            title="Centrer"
          >
            &#8676;&#8677;
          </button>
          <button
            type="button"
            className={`toolbar-btn ${textAlign === 'right' ? 'active' : ''}`}
            onClick={() => setTextAlign('right')}
            title="Aligner à droite"
          >
            &#8677;
          </button>
          <button
            type="button"
            className={`toolbar-btn ${textAlign === 'justify' ? 'active' : ''}`}
            onClick={() => setTextAlign('justify')}
            title="Justifier"
          >
            &#8801;
          </button>
        </div>
      </div>
    </div>
  );
}

RichTextToolbar.propTypes = {
  block: PropTypes.shape({
    fontSize: PropTypes.string,
    fontFamily: PropTypes.string,
    fontWeight: PropTypes.string,
    fontStyle: PropTypes.string,
    textDecoration: PropTypes.string,
    textAlign: PropTypes.string,
  }).isRequired,
  onUpdate: PropTypes.func.isRequired,
};

export default RichTextToolbar;
